/**
 * Opens an outside page in the in-app browser (SFSafariViewController) on the
 * native shell, so a grown-up who taps the kidSAFE seal in Settings > Legal
 * comes back to the app when they close it. The adapter layer is the only place
 * allowed to import `@capacitor/*` (`__tests__/adapterBoundary.test.ts`).
 * Off-device it does nothing and never loads the plugin; the caller lets the
 * browser follow the link itself.
 */
import { Capacitor } from "@capacitor/core";

/** True when the page opened in the in-app browser; false off-device or if the plugin is missing. */
export async function openInAppBrowser(url: string): Promise<boolean> {
  if (!Capacitor.isNativePlatform()) return false;
  try {
    const { Browser } = await import("@capacitor/browser");
    await Browser.open({ url });
    return true;
  } catch {
    // A build without the plugin (before the next app update) answers
    // "not implemented": fall back to the system browser.
    return false;
  }
}
